<template>
  <div class="dashboard">
    <screening-stage-card
      :review="review"
      @open-workflow="redirectToScreeningWorkflow"
    />
    <full-text-review-stage-card
      :review="review"
      @open-workflow="redirectToFullTextReviewWorkflow"
    />
    <data-extraction-stage-card
      :review="review"
      @open-workflow="redirectToDataExtractionWorkflow"
    />
  </div>
</template>

<script>
import ScreeningStageCard from './ScreeningStageCard';
import FullTextReviewStageCard from './FullTextReviewStageCard';
import DataExtractionStageCard from './DataExtractionStageCard';
import { Review } from '@/models';

export default {
  name: 'Dashboard',
  components: {
    ScreeningStageCard,
    FullTextReviewStageCard,
    DataExtractionStageCard,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  methods: {
    redirectToScreeningWorkflow() {
      this.$router.push(`/review/${this.review.id}/screening/screen`);
    },
    redirectToFullTextReviewWorkflow() {
      this.$router.push(`/review/${this.review.id}/full-text-review`);
    },
    redirectToDataExtractionWorkflow() {
      this.$router.push(`/review/${this.review.id}/data-extraction`);
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  display: grid;
  gap: 24px;

  max-width: 1300px;
  width: 100%;
}
</style>
